import { PresignedUrlProvider } from "./PresignedUrlProvider";
import { CachedFileRenderer } from "./CachedFileRenderer";
import { Loader2 } from "lucide-react";

interface FileViewerProps {
    fileKey: string;
    isPdf: boolean;
}

export function FileViewer({ fileKey, isPdf }: FileViewerProps) {
    return (
        <PresignedUrlProvider fileName={fileKey}>
            {({ url, isLoading, error }) => {
                if (isLoading)
                    return (
                        <div className="flex flex-col items-center justify-center h-full gap-2">
                            <Loader2 className="h-6 w-6 animate-spin" />
                            <span className="text-xs font-semibold">
                                Requesting permission...
                            </span>
                        </div>
                    );
                if (error)
                    return (
                        <div className="text-red-500">
                            Failed: {error.message}
                        </div>
                    );
                if (!url) return <div>No document available</div>;

                // Use the separate component for document rendering with caching
                return (
                    <CachedFileRenderer
                        url={url}
                        fileKey={fileKey}
                        isPdf={isPdf}
                    />
                );
            }}
        </PresignedUrlProvider>
    );
}
